import { render, staticRenderFns } from "./HelpMessage.vue?vue&type=template&id=1edb81a6&"
import script from "./HelpMessage.vue?vue&type=script&lang=js&"
export * from "./HelpMessage.vue?vue&type=script&lang=js&"
import style0 from "./HelpMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports